let g_ok = true;
let g_id = "123";
let p_price = 10;
let collections_list = [];
let mode = 0;
let t_scale = 1;
let g_area = 0;
let munit = 1;
let step = 1;
let type = 1;
let m_width = 0;
let m_length = 0;
let p_cnt = 0;
let manual_cut = 0;
let manual_cut_tapelength = 0;
let clip_id_list = [
  "49098750165333", // 0. High Tack Seaming Adhesive 
  "49098755408213", //1. Jointing Tape
  "49098773299541", // 2. Heavy Duty Weed Control Fabric Membrane
  "49098764026197", // 3. Weed Fabric Fixing Pegs
  "49098761470293", // 4. Galvanised Green Staple Pegs
  "49098762617173", // 5. 2-Part PU Adhesive
  "49098758979925", // 6. Galvinised Green Nails
  "49510380110165", // 7. 10mm Artificial Grass Underlay
  "49510405275989", // 8. 15mm Artificial Grass Underlay
  "49508722737493", // 9 Underlay Adhesive
];
let clip_cnt_list = Array(9).fill(0);
let clip_title_list = [
  "High Tack Seaming Adhesive", // 0. High Tack Seaming Adhesive 
  "Jointing Tape", //1. Jointing Tape
  "Heavy Duty Weed Control Fabric Membrane", // 2. Heavy Duty Weed Control Fabric Membrane
  "Weed Fabric Fixing Pegs", // 3. Weed Fabric Fixing Pegs
  "Galvanised Green Staple Pegs", // 4. Galvanised Green Staple Pegs
  "2-Part PU Adhesive", // 5. 2-Part PU Adhesive
  "Galvinised Green Nails", // 6. Galvinised Green Nails
  "10mm Artificial Grass Underlay", // 7. 10mm Artificial Grass Underlay
  "15mm Artificial Grass Underlay", // 8. 15mm Artificial Grass Underlay
  "Underlay Adhesive", // 9 Underlay Adhesive
];
let clip_unit_list = [
  "tubes", // 0. High Tack Seaming Adhesive 
  "m", //1. Jointing Tape
  "m2", // 2. Heavy Duty Weed Control Fabric Membrane
  "packs of 10 pegs", // 3. Weed Fabric Fixing Pegs
  "packs of 10 pegs", // 4. Galvanised Green Staple Pegs
  "packs", // 5. 2-Part PU Adhesive
  "packs of 20 nails",// 6. Galvinised Green Nails
  "m2", // 7. 10mm Artificial Grass Underlay
  "m2", // 8. 15mm Artificial Grass Underlay
  "tubes", // 9 Underlay Adhesive
];
let clip_price_list = [
  8.99, // 0. High Tack Seaming Adhesive 
  1.99, //1. Jointing Tape
  1, // 2. Heavy Duty Weed Control Fabric Membrane
  2.99, // 3. Weed Fabric Fixing Pegs
  4.99, // 4. Galvanised Green Staple Pegs
  9.99, // 5. 2-Part PU Adhesive
  9.99, // 6. Galvinised Green Nails
  6.99, // 7. 10mm Artificial Grass Underlay
  9.99, // 8. 15mm Artificial Grass Underlay
  57.99 // 9 Underlay Adhesive
];
let wide_list = [];
let last_divide_factor = false;

let clip_flag = Array(9).fill(0); // 0 is disabled, 1 is enabled
let page_flag = 1; // product page 0 and calculator page 1 

function setWideList() {
  wide_list = [];
  last_divide_factor = false;

  if (Array.isArray(collections_list)) {
    collections_list.forEach((collection) => {
      const c = collection.toLowerCase();
      if (
        (c === "5m wide artificial grass manchester" || c === "5m wide artificial grass" || c === "5m wide wall grass") &&
        !wide_list.includes(5)
      ) {
        wide_list.push(5);
      } else if (
        (c === "4m wide artificial grass" || c === "4m wide wall grass") &&
        !wide_list.includes(4)
      ) {
        wide_list.push(4);
      } else if (
        (c === "3m wide artificial grass" || c === "3m wide wall grass") &&
        !wide_list.includes(3)
      ) {
        wide_list.push(3);
      } else if (
        (c === "2m wide artificial grass" || c === "2m wide wall grass") &&
        !wide_list.includes(2)
      ) {
        wide_list.push(2);
      } else if (
        (c === "1m wide artificial grass" || c === "1m wide wall grass") &&
        !wide_list.includes(1)
      ) {
        wide_list.push(1);
      }
    });
    wide_list = wide_list.slice().sort((a, b) => b - a);
  } else {
    console.error("collections_list is not an array");
  }

  if (
    wide_list[wide_list.length - 1] > 2 &&
    m_width > wide_list[wide_list.length - 1]
  ) {
    wide_list.push(wide_list[wide_list.length - 1] / 2);
    last_divide_factor = true;
  }
}

function setCollectionLabel() {
  var labelTxt = "";
  var twide_list = [...wide_list];
  twide_list.sort();
  twide_list.forEach((wide, index) => {
    if (index < twide_list.length - 2) {
      labelTxt += wide + "m, ";
    } else if (index < twide_list.length - 1) {
      labelTxt += wide + "m & ";
    } else {
      labelTxt += wide + "m ";
    }
  });
  $("#product-collections").text("Available in " + labelTxt + "wide");
}

function setSelectedUnit(unit) {
  munit = unit;
  $(".unit-btn").removeClass("selected");

  if (munit === 1) {
    t_scale = 1;
    // METRES
    $("#lawn-length, #lawn-width").attr("step", "0.01");
    $("#metres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  } else if (munit === 2) {
    t_scale = 0.0254;
    // FEET
    $("#feet-btn").addClass("selected");
    $("#input-row-1").hide();
    $("#input-row-2").show();
    $("#lawn-length-2-f, #lawn-width-2-f, #lawn-length-2-i, #lawn-width-2-i").attr("step", "1");
  } else if (munit === 3) {
    t_scale = 0.01;
    // CENTEMETRES
    $("#centimetres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
    $("#lawn-length, #lawn-width").attr("step", "1");
  } else if (munit === 4) {
    // INCHES
    t_scale = 0.0256410256;
    $("#inches-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
    $("#lawn-length, #lawn-width").attr("step", "1");
  }

  refreshData();

  if (mode == 0) {
    $("#inner").empty();
    addManualCut();
  }
}

function selectType(type_num) {
  type = type_num;
  $(".option-item").removeClass("selected");

  // Add selected class to the corresponding button
  if (type === 1) {
    $("#regular-grass").addClass("selected");
  } else if (type === 2) {
    $("#flags").addClass("selected");
  } else if (type === 3) {
    $("#decking").addClass("selected");
  } else if (type === 4) {
    $("#tarmac").addClass("selected");
  } else if (type === 0) {
    $("#none").addClass("selected");
  }
}

function calculatePrice(width, length, tapelength) {
  g_area = width * length;

  console.log("calculatePrice width", width);
  console.log("calculatePrice type", type);
  console.log("calculatePrice tapelength", tapelength);

  clip_cnt_list = Array(9).fill(0);

  console.log("recommendProducts ", recommendProducts[0]);
    
  if(Math.ceil(tapelength) > 0){
    if (recommendProducts[0].accessories_enable__0){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = recommendProducts[0].accessories_required__0 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__1) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = recommendProducts[0].accessories_required__1 ? 1 : 0;
    }
  }
  if (type === 1) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
  } else if (type === 2) {
    if (recommendProducts[0]?.accessories_enable__5) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = recommendProducts[0].accessories_required__5 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
    if (recommendProducts[0]?.accessories_enable__9) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); // Underlay Adhesive
      clip_flag[9] = recommendProducts[0].accessories_required__9 ? 1 : 0; 
    }
  } else if (type === 3) {
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5);
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }    
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
  } else if (type === 4) {
  } else if (type === 0) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
  }

  showQuote();
}

function calculatePrice2(area, tapelength, around) {
  g_area = area;

  clip_cnt_list = Array(9).fill(0);
  
  if(Math.ceil(tapelength) > 0){
    if (recommendProducts[0].accessories_enable__0){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = recommendProducts[0].accessories_required__0 ? 1 : 0; 
    }
    if (recommendProducts[0]?.accessories_enable__1) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = recommendProducts[0].accessories_required__1 ? 1 : 0;
    }
  }
  
  if (type === 1) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
  } else if (type === 2) {
    if (recommendProducts[0]?.accessories_enable__5) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = recommendProducts[0].accessories_required__5 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
    if (recommendProducts[0]?.accessories_enable__9) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); //Underlay Adhesive
      clip_flag[9] = recommendProducts[0].accessories_required__9 ? 1 : 0;
    }
  } else if (type === 3) {
    if (recommendProducts[0]?.accessories_enable__6) {
      clip_cnt_list[6] = Math.ceil(g_area / 5); // Galvinised Green 
      clip_flag[6] = recommendProducts[0].accessories_required__6 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }    
  } else if (type === 4) {
  } else if (type === 0) {
    if (recommendProducts[0]?.accessories_enable__2) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = recommendProducts[0].accessories_required__2 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__3) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = recommendProducts[0].accessories_required__3 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__4) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = recommendProducts[0].accessories_required__4 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__7) {
      clip_cnt_list[7] = Math.ceil(g_area); //10mm Artificial Grass Underlay
      clip_flag[7] = recommendProducts[0].accessories_required__7 ? 1 : 0;
    }
    if (recommendProducts[0]?.accessories_enable__8) {
      clip_cnt_list[8] = Math.ceil(g_area); //15mm Artificial Grass Underlay
      clip_flag[8] = 0; // Always crossed off by default
    }
  }

  showQuote();
}

function showQuote() {
  let total_grass_price = g_area * p_price;
  $("#grass-price").text(p_price);
  $("#total-area").text(g_area.toFixed(2));
  $("#cost-of-grass").text(total_grass_price.toFixed(2));

  var clips_total_price = 0;
  var clip_quote_view = $("#clip-quote-view");
  clip_quote_view.empty();

  for (let i = 0; i < clip_id_list.length; i++) {
    if (clip_cnt_list[i] > 0) {
      var rowDiv = $("<div>", { class: "row" }).attr("id", "clip-row-" + i);

      console.log("clip_flag[i]", clip_flag[i]);
      
      var pTag1 = $("<p>").html(
        clip_title_list[i] +
          " (" +
          clip_cnt_list[i] +
          " " +
          clip_unit_list[i] +
          ")"
      );
      var pTag2 = $("<p>", { class: "price" }).text(
        "£" + (clip_cnt_list[i] * clip_price_list[i]).toFixed(2)
      );
      var btnTag = $("<button>")
        .attr("id", "rmv-btn-" + i)
        .addClass("rmv-btn")
        .text("")
        .on("click", function () {
          removeClipBtnClick(i);
        });
      var tagDiv = $("<div>", { class: "tag-group" });

      tagDiv.append(pTag1);
      tagDiv.append(pTag2);
      rowDiv.append(tagDiv);

      if (clip_flag[i] === 0) {
        rowDiv.addClass("clip-row-disable");
        btnTag.text("×");
      } else if (clip_flag[i] == 1) {
        clips_total_price += clip_cnt_list[i] * clip_price_list[i];
        btnTag.html(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tick" 
          viewBox="0 0 515.556 515.556" width="26" height="26">
            <path d="M0 274.226l176.549 176.886L515.556 112.44l-48.67-47.997-290.337 290L47.996 225.891z"></path>
          </svg>`);
      }
      rowDiv.append(btnTag);

      clip_quote_view.append(rowDiv);
    }
  }

  $("#accessory-total-price").text(clips_total_price.toFixed(2));
  $("#final-total-grass").text("£" + total_grass_price.toFixed(2));
  $("#final-total").text(
    "£" + (clips_total_price + total_grass_price).toFixed(2)
  );
}

function removeClipBtnClick(index) {
  if (clip_flag[index] == 0) {
    clip_flag[index] = 1;
  } else if (clip_flag[index] == 1) {
    clip_flag[index] = 0;
  }

  if (clip_flag.every((item) => item === 0)) {
    $("#check-out-btn-1").hide();
  } else {
    $("#check-out-btn-1").show();
  }

  showQuote();
}

function selectMode(m) {
  mode = m;
  if (m == 0) {
    $("#cal-use").removeClass("selected");
    $("#cus-use").addClass("selected");
    $("#calculator-mode").hide();
    $("#custom-cutter").show();
  } else {
    $("#cal-use").addClass("selected");
    $("#cus-use").removeClass("selected");
    $("#calculator-mode").show();
    $("#custom-cutter").hide();
  }

  refreshData();
}

function calculateGrassRolls(width, max) {
  let results = [];

  if (width <= 0) {
    return { cap: width, widecut: [], step: 0, cover: 0 };
  }

  for (let i = 0; i < wide_list.length; i++) {
    if (wide_list[i] <= max) {
      let result = calculateGrassRolls(width - wide_list[i], wide_list[i]);
      results.push({ result: result, wide: wide_list[i] });
    }
  }

  let bestResult = results[0].result;
  let chooseWide = results[0].wide;

  for (let i = 1; i < results.length; i++) {
    if (results[i].result.cap > bestResult.cap) {
      bestResult = results[i].result;
      chooseWide = results[i].wide;
    } else if (results[i].result.cap === bestResult.cap) {
      if (results[i].result.step < bestResult.step) {
        bestResult = results[i].result;
        chooseWide = results[i].wide;
      }
    }
  }

  bestResult.widecut.unshift(chooseWide);
  bestResult.step++;
  bestResult.cover += chooseWide;

  return bestResult;
}

function drawGrassPlan(
  canvasId,
  width,
  length,
  key_box_id = "#key-box",
  key_box_2_id = "#key-box-2",
  canvasWidth = 400,
  canvasHeight = 250
) {
  let canvas = document.getElementById(canvasId);
  let context = canvas.getContext("2d");
  let length_label = length;

  let result = calculateGrassRolls(width, wide_list[0]);

  let rolls = result.widecut;

  if (rolls.length >= 2) {
    $(key_box_id).show();
  } else {
    $(key_box_id).hide();
  }

  calculatePrice(result.cover, length, length * (rolls.length - 1));

  width = result.cover + rolls.length * 1;

  if (
    rolls[rolls.length - 1] == wide_list[wide_list.length - 1] &&
    last_divide_factor == true
  ) {
    last_divide_factor = true;
  } else {
    last_divide_factor = false;
  }

  if (last_divide_factor) {
    $(key_box_2_id).show();
  } else {
    $(key_box_2_id).hide();
  }

  let scaleX = canvasWidth / width;
  let scaleY = canvasHeight / length;
  const scale = Math.min(scaleX, scaleY);

  if (scaleY <= scaleX / 2) {
    scaleX = scale * 2;
  } else if (scaleX <= scaleY / 2) {
    scaleY = scale * 2;
  } else {
    scaleX = scale;
    scaleY = scale;
  }

  width *= scaleX;
  length *= scaleY;

  canvas.width = width;
  canvas.height = length;

  let currentX = 0;
  let dashX;
  let dashY;

  rolls.forEach((roll, index) => {
    context.fillStyle = "#95C11F99";
    context.fillRect(currentX, 0, (roll + 1) * scaleX, length);

    context.fillStyle = "#FFFFFF";
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.font = `${scale * 0.01 * 16 + 10}px Arial`;

    if (index < rolls.length - 1 || !last_divide_factor) {
      let textY = length / 2;

      const textX = currentX + ((roll + 1) * scaleX) / 2;
      const delta = scaleY * 0.011 * 16 * 1.1 + 12;

      context.fillText(`${length_label}m`, textX, textY - delta);
      context.fillText("x", textX, textY);
      context.fillText(`${roll}m`, textX, textY + delta);
    }

    currentX += (roll + 1) * scaleX;
  });

  currentX = 0;

  rolls.forEach((roll, index) => {
    dashX = currentX + (roll + 1) * scaleX;
    dashY = 0;

    context.strokeStyle = "#000";
    context.lineWidth = 2;

    while (dashX < width && dashY < length) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX, dashY + 6);
      context.stroke();
      dashY += 6 + 3;
    }

    currentX += (roll + 1) * scaleX;
  });

  if (last_divide_factor) {
    let roll = rolls[rolls.length - 1];

    dashX = width - (roll + 1) * scaleX;
    dashY = length / 2;
    context.strokeStyle = "#000";
    context.lineWidth = 2;

    while (dashX < width) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX + 6, dashY);
      context.stroke();
      dashX += 6 + 3;
    }

    context.fillStyle = "#FFFFFF";
    context.font = `${scale * 0.01 * 16 + 10}px Arial`;
    context.textAlign = "center";
    context.textBaseline = "middle";
    let textY = length / 4;
    let textX = width - ((roll + 1) / 2) * scaleX;
    let delta = scaleY * 0.011 * 16 * 1.1 + 12;
    context.fillText(`${length_label / 2}m`, textX, textY - delta);
    context.fillText("x", textX, textY);
    context.fillText(`${roll}m`, textX, textY + delta);
    textY = (length * 3) / 4;
    context.fillText(`${length_label / 2}m`, textX, textY - delta);
    context.fillText("x", textX, textY);
    context.fillText(`${roll}m`, textX, textY + delta);
  }
}

function addtoCart(with_clips) {
  var productsToAdd = [{ id: g_id, quantity: Math.ceil(g_area) }];

  if (with_clips == true) {
    for (i = 0; i < clip_id_list.length; i++) {
      if (clip_cnt_list[i] > 0 && clip_flag[i] == 1) {
        productsToAdd.push({
          id: clip_id_list[i],
          quantity: clip_cnt_list[i],
        });
      }
    }
  }

  let formData = {
    items: productsToAdd,
  };

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      $("input, button, select").prop("disabled", false);
      window.location.href = "https://grasscashandcarry.co.uk/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added on your cart!");
      console.error("Error:", error);
    });
}

function unitText(flag = 0) {
  if (munit === 1) {
    return ["m"];
  } else if (munit === 2) {
    return ["ft", (flag == 0)?"inches":"in"];
  } else if (munit === 4) {
    return ["in", (flag == 0)?"inches":"in"];
  } else {
    return ["cm"];
  }
}

function addManualCut() {
  var $cutRow = $("<div>")
    .attr("id", "cus-row-" + manual_cut)
    .addClass("cut-row cut-row-" + manual_cut);

  var $lengthInput;

  if (munit === 2) { // Feet and Inches
    $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $feetInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-f",
      name: "cutter-length-" + manual_cut + "-f",
      type: "text",
      value: "",
    });
    var $inchInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-i",
      name: "cutter-length-" + manual_cut + "-i",
      type: "text",
      value: "",
    });

    $lengthInput.append($feetInput);
    $lengthInput.append($("<p>").html("ft"));
    $lengthInput.append($inchInput);
    $lengthInput.append($("<p>").html("in"));

    let feetPattern = /^\d{0,2}$/;
    let inchPattern = /^\d{0,2}$/;

    $feetInput.data("prev", "");
    $feetInput.on("input", function () {
      let value = $(this).val();
      if (feetPattern.test(value)) {
        $(this).data("prev", value);
        if (value.length === 2) {
          $inchInput.focus();
        }
        // Check max value after digit limit (25 meters)
        let totalInches = parseInt(value) * 12 + parseInt($inchInput.val() || 0);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81; // Fixed to 81 feet
          let maxInches = 3; // Fixed to 3 inches
          $(this).val(maxFeet.toString().slice(0, 2));
          $inchInput.val(maxInches.toString().slice(0, 2));
          $(this).data("prev", $(this).val());
          $inchInput.data("prev", $inchInput.val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      } else {
        let truncated = value.replace(/\D/g, "").slice(0, 2);
        $(this).val(truncated);
        $(this).data("prev", truncated);
        if (truncated.length === 2) {
          $inchInput.focus();
        }
        // Check max value after truncation
        let totalInches = parseInt(truncated) * 12 + parseInt($inchInput.val() || 0);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81; // Fixed to 81 feet
          let maxInches = 3; // Fixed to 3 inches
          $(this).val(maxFeet.toString().slice(0, 2));
          $inchInput.val(maxInches.toString().slice(0, 2));
          $(this).data("prev", $(this).val());
          $inchInput.data("prev", $inchInput.val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      }
      calManualCutValue();
    });

    $inchInput.data("prev", "");
    $inchInput.on("input", function () {
      let value = $(this).val();
      if (inchPattern.test(value)) {
        $(this).data("prev", value);
        // Check max value after digit limit (25 meters)
        let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt(value);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81; // Fixed to 81 feet
          let maxInches = 3; // Fixed to 3 inches
          $feetInput.val(maxFeet.toString().slice(0, 2));
          $(this).val(maxInches.toString().slice(0, 2));
          $(this).data("prev", $(this).val());
          $feetInput.data("prev", $feetInput.val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      } else {
        let truncated = value.replace(/\D/g, "").slice(0, 2);
        $(this).val(truncated);
        $(this).data("prev", truncated);
        // Check max value after truncation
        let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt(truncated);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81; // Fixed to 81 feet
          let maxInches = 3; // Fixed to 3 inches
          $feetInput.val(maxFeet.toString().slice(0, 2));
          $(this).val(maxInches.toString().slice(0, 2));
          $(this).data("prev", $(this).val());
          $feetInput.data("prev", $feetInput.val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      }
      calManualCutValue();
    });
  } else {
    $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $lInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut,
      name: "cutter-length-" + manual_cut,
      type: "text",
      value: "",
    });

    $lengthInput.append($lInput);

    let pattern;
    if (munit === 1) { // Metres
      pattern = /^\d{0,2}(\.\d{0,2})?$/;
    } else if (munit === 3) { // Centimetres
      pattern = /^\d{0,4}$/;
    } else if (munit === 4) { // Inches
      pattern = /^\d{0,3}$/;
    }

    $lInput.data("prev", "");
    $lInput.on("input", function () {
      let value = $(this).val();
      if (pattern.test(value)) {
        $(this).data("prev", value);
        // Check max value after digit limit (25 meters)
        let convertedValue = parseFloat(value) * t_scale;
        if (munit === 1 && parseFloat(value) > 25) { // Direct check for Metres
          $(this).val("25");
          $(this).data("prev", "25");
          $("#cus-cut-warning").text("Maximum length is 25 meters.").show();
        } else if (munit === 3 && convertedValue > 25) { // Centimetres check
          let maxInput = Math.floor(25 / t_scale); // Approximately 2500 cm
          $(this).val(maxInput.toString().slice(0, 4)); // Cap at 2500 and keep 4 digits
          $(this).data("prev", $(this).val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (2500 cm).").show();
        } else if (munit === 4 && convertedValue > 25) { // Inches check
          let maxInput = Math.floor(25 / t_scale); // Approximately 975 inches
          $(this).val(maxInput.toString().slice(0, 3)); // Cap at 975 and keep 3 digits
          $(this).data("prev", $(this).val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (975 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      } else {
        let truncated;
        if (munit === 1) { // Metres
          let parts = value.split(".");
          let beforeDecimal = parts[0].replace(/\D/g, "").slice(0, 2);
          let afterDecimal = parts[1] ? parts[1].replace(/\D/g, "").slice(0, 2) : "";
          truncated = beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
        } else if (munit === 3) { // Centimetres
          truncated = value.replace(/\D/g, "").slice(0, 4);
        } else if (munit === 4) { // Inches
          truncated = value.replace(/\D/g, "").slice(0, 3); // Enforce 3-digit limit
        }
        $(this).val(truncated);
        $(this).data("prev", truncated);
        // Check max value after truncation
        let convertedValue = parseFloat(truncated) * t_scale;
        if (munit === 1 && parseFloat(truncated) > 25) { // Direct check for Metres
          $(this).val("25");
          $(this).data("prev", "25");
          $("#cus-cut-warning").text("Maximum length is 25 meters.").show();
        } else if (munit === 3 && convertedValue > 25) { // Centimetres check
          let maxInput = Math.floor(25 / t_scale); // Approximately 2500 cm
          $(this).val(maxInput.toString().slice(0, 4)); // Cap at 2500 and keep 4 digits
          $(this).data("prev", $(this).val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (2500 cm).").show();
        } else if (munit === 4 && convertedValue > 25) { // Inches check
          let maxInput = Math.floor(25 / t_scale); // Approximately 975 inches
          $(this).val(maxInput.toString().slice(0, 3)); // Cap at 975 and keep 3 digits
          $(this).data("prev", $(this).val());
          $("#cus-cut-warning").text("Maximum length is 25 meters (975 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      }
      calManualCutValue();
    });
  }

  var $btnTag = $("<button>")
    .attr("id", "cus-rmv-btn-" + manual_cut)
    .addClass("rmv-btn")
    .text("x")
    .on("click", function () {
      $cutRow.remove();
      calManualCutValue();
      manual_cut--;
    });

  var $widthSelect = $("<select>")
    .attr({
      id: "SingleOptionSelector-" + manual_cut,
      "data-single-option-selector": "",
      "data-index": "option1",
    })
    .addClass("single-option-selector width_select")
    .on("input", function () {
      calManualCutValue();
    });

  var twide_list = [...wide_list];
  twide_list.sort();

  twide_list.forEach((wide) => {
    let label;

    if (munit === 2) {
      const feet = Math.floor(wide / t_scale / 12);
      const inches = Math.round(wide / t_scale - feet * 12);
      const unitTextParts = unitText(page_flag);
      label = `${feet}${unitTextParts[0]} ${inches}${unitTextParts[1]} (${wide}m)`;
    } else if (munit === 3) {
      label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
    } else if (munit === 4) {
      label = `${Math.round(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
    } else {
      label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]}`;
    }

    $widthSelect.append($("<option>").attr("value", wide).text(label));
  });

  $widthSelect.val($widthSelect.find("option:first").val());

  $cutRow.append($btnTag);
  $cutRow.append($lengthInput);
  $cutRow.append($widthSelect);

  $("#inner").append($cutRow);

  manual_cut++;

  calManualCutValue();
}

function calManualCutValue() {
  g_area = 0;
  manual_cut_tapelength = 0;
  let first_length = 0;

  $("#custom-cutter #inner .cut-row").each(function (index) {
    var length;      

    if (index === 0) {
      if (munit == 2) {
        first_length = parseFloat(
          (
            parseInt($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
            parseInt($(this).find("input").eq(1).val() || 0) * t_scale
          )
        );
      } else {
        first_length = parseFloat($(this).find("input").val() || 0);
      }
    }

    if (munit == 2) {
      length = parseFloat(
        (
          parseInt($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
          parseInt($(this).find("input").eq(1).val() || 0) * t_scale
        )
      );
    } else {
      length = parseFloat($(this).find("input").val() || 0);
    }
    
    if (munit == 4) {
      length = parseFloat(
        (parseInt($(this).find("input").val() || 0) * t_scale)
      );
    }

    var width = parseFloat(
      (parseFloat($(this).find("select").val()) || 0)
    );

    g_area += length * width;
    manual_cut_tapelength += length;
  });

  g_area = g_area;
  manual_cut_tapelength = parseFloat(manual_cut_tapelength) - first_length;
}

function addtoCartManualCut() {
  var productsToAdd = [{ id: g_id, quantity: Math.ceil(g_area) }];

  let formData = {
    items: productsToAdd,
  };

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      window.location.href = "/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added on your cart!");
      console.error("Error:", error);
    });
}

function refreshData() {
  g_area = 0;
  m_width = 0;
  m_length = 0;
  manual_cut = 0;
  manual_cut_tapelength = 0;
  clip_flag.fill(0);

  $("#lawn-width").val("");
  $("#lawn-length").val("");
  $(
    "#quote-section, #quote-box, #quote-warning, #step-1-warning, #cus-cut-warning"
  ).hide();
  $("#checkout-warning-msg").hide();
  $("input, button, select").prop("disabled", false);
}

$("input").on("wheel", function (e) {
  e.preventDefault();
});

// Metres, Inches, Centimetres - Single input fields (#lawn-length, #lawn-width)
$("#lawn-length, #lawn-width").on("input", function () {
  let value = $(this).val();
  let pattern;

  if (munit === 1) { // Metres
    pattern = /^\d{0,2}(\.\d{0,2})?$/;
  } else if (munit === 3) { // Centimetres
    pattern = /^\d{0,4}$/;
  } else if (munit === 4) { // Inches
    pattern = /^\d{0,3}$/;
  }

  if (munit !== 2) { // Skip Feet and Inches for now (handled separately)
    if (pattern.test(value)) {
      $(this).data("prev", value);
      // Check max value after digit limit (25 meters)
      let convertedValue = parseFloat(value) * t_scale;
      if (munit === 1 && parseFloat(value) > 25) { // Direct check for Metres
        $(this).val("25");
        $(this).data("prev", "25");
        $("#step-1-warning").text("Maximum length is 25 meters.").show();
      } else if (munit === 3 && convertedValue > 25) { // Centimetres check
        let maxInput = Math.floor(25 / t_scale); // Approximately 2500 cm
        $(this).val(maxInput.toString().slice(0, 4)); // Cap at 2500 and keep 4 digits
        $(this).data("prev", $(this).val());
        $("#step-1-warning").text("Maximum length is 25 meters (2500 cm).").show();
      } else if (munit === 4 && convertedValue > 25) { // Inches check
        let maxInput = Math.floor(25 / t_scale); // Approximately 975 inches
        $(this).val(maxInput.toString().slice(0, 3)); // Cap at 975 and keep 3 digits
        $(this).data("prev", $(this).val());
        $("#step-1-warning").text("Maximum length is 25 meters (975 inches).").show();
      } else {
        $("#step-1-warning").hide();
      }
    } else {
      let truncated;
      if (munit === 1) { // Metres
        let parts = value.split(".");
        let beforeDecimal = parts[0].replace(/\D/g, "").slice(0, 2);
        let afterDecimal = parts[1] ? parts[1].replace(/\D/g, "").slice(0, 2) : "";
        truncated = beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
      } else if (munit === 3) { // Centimetres
        truncated = value.replace(/\D/g, "").slice(0, 4);
      } else if (munit === 4) { // Inches
        truncated = value.replace(/\D/g, "").slice(0, 3); // Enforce 3-digit limit
      }
      $(this).val(truncated);
      $(this).data("prev", truncated);
      // Check max value after truncation
      let convertedValue = parseFloat(truncated) * t_scale;
      if (munit === 1 && parseFloat(truncated) > 25) { // Direct check for Metres
        $(this).val("25");
        $(this).data("prev", "25");
        $("#step-1-warning").text("Maximum length is 25 meters.").show();
      } else if (munit === 3 && convertedValue > 25) { // Centimetres check
        let maxInput = Math.floor(25 / t_scale); // Approximately 2500 cm
        $(this).val(maxInput.toString().slice(0, 4)); // Cap at 2500 and keep 4 digits
        $(this).data("prev", $(this).val());
        $("#step-1-warning").text("Maximum length is 25 meters (2500 cm).").show();
      } else if (munit === 4 && convertedValue > 25) { // Inches check
        let maxInput = Math.floor(25 / t_scale); // Approximately 975 inches
        $(this).val(maxInput.toString().slice(0, 3)); // Cap at 975 and keep 3 digits
        $(this).data("prev", $(this).val());
        $("#step-1-warning").text("Maximum length is 25 meters (975 inches).").show();
      } else {
        $("#step-1-warning").hide();
      }
    }
  }
});

// Feet and Inches - Separate inputs (#lawn-length-2-f, #lawn-length-2-i, #lawn-width-2-f, #lawn-width-2-i)
$("#lawn-length-2-f, #lawn-width-2-f").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/;
  let $nextInput = $(this).parent().find("input").eq(1); // Corresponding inches field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    if (value.length === 2) {
      $nextInput.focus();
    }
    // Check max value after digit limit (25 meters)
    let totalInches = parseInt(value) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    if (convertedValue > 25) {
      let maxFeet = 81; // Fixed to 81 feet
      let maxInches = 3; // Fixed to 3 inches
      $(this).val(maxFeet.toString()); // Set to "81"
      $nextInput.val(maxInches.toString()); // Set to "3"
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
    } else {
      $("#step-1-warning").hide();
    }
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2);
    $(this).val(truncated);
    $(this).data("prev", truncated);
    if (truncated.length === 2) {
      $nextInput.focus();
    }
    // Check max value after truncation
    let totalInches = parseInt(truncated) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    if (convertedValue > 25) {
      let maxFeet = 81; // Fixed to 81 feet
      let maxInches = 3; // Fixed to 3 inches
      $(this).val(maxFeet.toString()); // Set to "81"
      $nextInput.val(maxInches.toString()); // Set to "3"
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
    } else {
      $("#step-1-warning").hide();
    }
  }
});

$("#lawn-length-2-i, #lawn-width-2-i").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/;
  let $feetInput = $(this).parent().find("input").eq(0); // Corresponding feet field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    // Enforce max inches of 12
    if (parseInt(value) > 12) {
      $(this).val("12");
      $(this).data("prev", "12");
    }
    // Check max value after digit limit (25 meters)
    let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt(value);
    let convertedValue = totalInches * t_scale;
    if (convertedValue > 25) {
      let maxFeet = 81; // Fixed to 81 feet
      let maxInches = 3; // Fixed to 3 inches
      $feetInput.val(maxFeet.toString()); // Set to "81"
      $(this).val(maxInches.toString()); // Set to "3"
      $(this).data("prev", $(this).val());
      $feetInput.data("prev", $feetInput.val());
      $("#step-1-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
    } else {
      $("#step-1-warning").hide();
    }
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2);
    $(this).val(truncated);
    $(this).data("prev", truncated);
    // Enforce max inches of 12
    if (parseInt(truncated) > 12) {
      $(this).val("12");
      $(this).data("prev", "12");
    }
    // Check max value after truncation
    let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt(truncated);
    let convertedValue = totalInches * t_scale;
    if (convertedValue > 25) {
      let maxFeet = 81; // Fixed to 81 feet
      let maxInches = 3; // Fixed to 3 inches
      $feetInput.val(maxFeet.toString()); // Set to "81"
      $(this).val(maxInches.toString()); // Set to "3"
      $(this).data("prev", $(this).val());
      $feetInput.data("prev", $feetInput.val());
      $("#step-1-warning").text("Maximum length is 25 meters (81 feet 3 inches).").show();
    } else {
      $("#step-1-warning").hide();
    }
  }
});

// Unit selection
$(".unit-btn").click(function () {
  let unitID = $(this).attr("id");

  if (unitID === "metres-btn") {
    setSelectedUnit(1);
  } else if (unitID === "feet-btn") {
    setSelectedUnit(2);
  } else if (unitID === "centimetres-btn") {
    setSelectedUnit(3);
  } else if (unitID === "inches-btn") {
    setSelectedUnit(4);
  }
});

$("#get-quote-btn").click(function () {
  if (wide_list.length == 0) {
    $('#wide-sel-warning').show();
    return;
  } else {
    $('#wide-sel-warning').hide();
  }
  if (mode == 1) {
    let lengthInput, widthInput;
    if (munit == 2) {
      let lengthFeet = parseInt($("#lawn-length-2-f").val() || 0);
      let lengthInches = parseInt($("#lawn-length-2-i").val() || 0);
      let widthFeet = parseInt($("#lawn-width-2-f").val() || 0);
      let widthInches = parseInt($("#lawn-width-2-i").val() || 0);
      m_width = (12 * t_scale * widthFeet + t_scale * widthInches);
      m_length = (12 * t_scale * lengthFeet + t_scale * lengthInches);
      lengthInput = `${lengthFeet}ft ${lengthInches}in`;
      widthInput = `${widthFeet}ft ${widthInches}in`;
    } else {
      let lengthVal = $("#lawn-length").val() || 0;
      let widthVal = $("#lawn-width").val() || 0;
      m_width = parseFloat(t_scale * widthVal);
      m_length = parseFloat(t_scale * lengthVal);
      lengthInput = lengthVal;
      widthInput = widthVal;

      // Apply max value check after conversion to metres
      if (munit === 1) {
        if (m_length > 25) {
          m_length = 25;
          $("#lawn-length").val("25");
        }
        if (m_length < 1) {
          $("#step-1-warning").show();
          return;
        }
        if (m_width < 1) {
          $("#step-1-warning").show();
          return;
        }
      } else if (munit === 3 || munit === 4) {
        if (m_length > 25) {
          let maxScaled = Math.floor(25 / t_scale);
          m_length = 25;
          $("#lawn-length").val(maxScaled);
        }
        if (m_width > 25) {
          let maxScaled = Math.floor(25 / t_scale);
          m_width = 25;
          $("#lawn-width").val(maxScaled);
        }
        if (lengthVal < 1 / t_scale || widthVal < 1 / t_scale) {
          $("#step-1-warning").show();
          return;
        }
      }
    }

    if (m_width >= 1 && m_length >= 1 && m_length <= 25) {
      if (m_width * m_length == 0) {
        return;
      }

      $("#step-1-warning").hide();
      $("#quote-title").text(
        "Your measurements (" + lengthInput + (munit === 1 ? "m" : munit === 3 ? "cm" : munit === 4 ? "in" : "") + " x " + widthInput + (munit === 1 ? "m" : munit === 3 ? "cm" : munit === 4 ? "in" : "") + ")"
      );
      $("#quote-section, #quote-box").show();
      drawGrassPlan(
        "grassCanvas",
        m_width,
        m_length,
        "#key-box",
        "#key-box-2",
        $(".result-box").first().width() - 60,
        $(".result-box").first().height() - 60
      );
      document.getElementById("quote-section").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      $("#step-1-warning").show();
      $("#quote-box").hide();
    }
  } else {
    calManualCutValue();
    calculatePrice2(g_area, manual_cut_tapelength, manual_cut_tapelength);
    if (g_area == 0) {
      return;
    }
    let firstRow = $("#custom-cutter #inner .cut-row").first();
    let lengthInput = munit === 2 
      ? `${firstRow.find("input").eq(0).val() || 0}ft ${firstRow.find("input").eq(1).val() || 0}in`
      : firstRow.find("input").val() || 0;
    let widthInput = firstRow.find("select").val() || 0;
    $("#quote-title").text(
      "Your measurements (" + lengthInput + (munit === 1 ? "m" : munit === 3 ? "cm" : munit === 4 ? "in" : "") + " × " + widthInput + "m)"
    );
    $("#quote-box").show();
    document.getElementById("quote-box").scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
});
$("#check-out-btn-1").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(true);
  } else {
    $("#checkout-warning-msg").show();
  }
});

$("#check-out-btn-0").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(false);
  } else {
    $("#checkout-warning-msg").show();
  }
});

// Type selection
$(".option-item").click(function () {
  let id = $(this).attr("id");

  if (id === "regular-grass") {
    selectType(1);
  } else if (id === "flags") {
    selectType(2);
  } else if (id === "decking") {
    selectType(3);
  } else if (id === "tarmac") {
    selectType(4);
  } else if (id === "none") {
    selectType(0);
  }

  $("#get-quote-btn").click();
});

$("#cutter-add").click(function (event) {
  addManualCut();
});

$("#cal-use").click(function () {
  selectMode(1);
});

$("#cus-use").click(function () {
  $("#inner").empty();
  addManualCut();
  selectMode(0);
});



function init() {
  refreshData();

  setSelectedUnit(1);
  selectType(1);

  $("#inner").empty();
  addManualCut();
  $("#quote-calculator").show();
  $("#calculator-mode").hide();
  selectMode(0);
}

setWideList();

setCollectionLabel();
// Initialize
init();